import React from "react";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import BlogDashboardHero from "../components/dashboard/BlogDashboardHero";
import YouMightAlsoLike from "../components/dashboard/YouMightAlsoLike";
import RecentlyPublished from "../components/dashboard/RecentlyPublished";
import WriterGuidelinesBanner from "../components/dashboard/WriterGuidelinesBanner";

export default function BlogDashboard() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="Blogs Dashboard | SoloConnect"
        description="Manage your travel blogs, drafts, and writer guidelines on SoloConnect."
        keywords="blog dashboard, my blogs, drafts, writer guidelines, SoloConnect"
      />
      <DashboardNavbar />
      <main className="flex-grow">
        <BlogDashboardHero />
        <YouMightAlsoLike />
        <RecentlyPublished />
        <WriterGuidelinesBanner />
      </main>
    </div>
  );
}
